// extracted by mini-css-extract-plugin
export var avatarContainer = "_4g-1";
export var largeAvatarContainer = "_4g-2";
export var smallAvatarContainer = "_4g-0";